module.exports = __webpack_public_path__ + "static/media/2.30531033.jpg";